import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ContactService } from '../contact.service';

@Component({
  selector: 'app-contact-infos',
  templateUrl: './contact-infos.component.html',
  styleUrls: ['./contact-infos.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ContactInfosComponent implements OnInit {

	public form: FormGroup;
	public loading: boolean;
	public disabled: boolean;
	public success: boolean;

	constructor(private _formBuilder: FormBuilder, private _service: ContactService) { }

	ngOnInit() {
        this.form = this._formBuilder.group({
            name: ['', Validators.required],
			email: ['', Validators.required],
			phone: '',
			description: ['', Validators.required],
			fromName: '',
			sendTo: ['contato@hvstolf.com.br'],
			subject: ['', Validators.required],
			template: ''
        });
	}


    onSubmit() {
        if (this.form.valid) {
			this.success = false;
			this.loading = true;
			this.disabled = true;
			const body = `
				A mensagem abaixo foi enviado pelo formulário de contato do site <br/>
				------------------------------------------------------------------ <br/>
				<b>Nome:</b> ` + this.form.controls['name'].value + ` <br/>
				<b>Telefone:</b> ` + this.form.controls['phone'].value + ` <br/>
				<br/><br/>
				<b>Mensagem:</b> ` + this.form.controls['description'].value;
			this.form.patchValue({'fromName': this.form.controls['name'].value});
			this.form.patchValue({'template': body});

            this._service.sendMessage(this.form.value)
            .subscribe(
                response => {
					this.loading = false;
					this.disabled = false;
					this.success = true;
					this.form.reset();
                },
                error => {
					this.loading = false;
					this.disabled = false;
                    console.error(error);
                }
            );
        } else {
            Object.keys(this.form.controls).forEach(field => {
                const control = this.form.get(field);
                control.markAsTouched();
            });
        }
    }

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/contact/contact-infos/contact-infos.component.ts